import { ScrollablePane, Sticky } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { Location, useLocationsQuery } from "@graphql";
import LocationCard from "../location-card/LocationCard";
import { useParams, useHistory, useLocation } from "react-router-dom";
import StatusHeader from "../../status-header/StatusHeader";
import BackHeader from "../../back-header/BackHeader";
import "./SelectLocation.css";

const SelectLocation: FunctionComponent = () => {
  const routerLocation = useLocation();
  const routerHistory = useHistory();
  const { idLocationParam } = useParams<{ idLocationParam: string }>();

  const [selectedLocationId, setSelectedLocationId] = useState<string>();

  const { data: allLocations, loading } = useLocationsQuery();

  useEffect(() => {
    setSelectedLocationId(idLocationParam);
  }, [allLocations]);

  useEffect(() => {}, [idLocationParam]);

  const onLocationClick = (id: string) => {
    const url = routerLocation.state as { prevUrlPath };
    const navigateTo = `${url.prevUrlPath}${url.prevUrlPath.endsWith("/") ? "" : "/"}${id}`;

    routerHistory.push(navigateTo);
  };

  const onRenderCell = (item: Location, index: number | undefined) => {
    return (
      <LocationCard
        key={`locationCard-${index}`}
        index={index}
        location={item}
        onLocationClick={onLocationClick}
        isActive={item._id === selectedLocationId}
      />
    );
  };

  return (
    <>
      {loading && <StatusHeader text={"Loading..."} isLoading={true} />}
      {!loading && (
        <ScrollablePane style={{ backgroundColor: "white" }}>
          <Sticky>
            <div className="back-header">
              <BackHeader title={"Locations"} />
            </div>
          </Sticky>
          {allLocations?.locations?.length > 0 &&
            allLocations?.locations.map((location, index) => onRenderCell(location, index))}
        </ScrollablePane>
      )}
    </>
  );
};

export default SelectLocation;
